import { Fit } from 'types/fit'
import { removeCookie } from '@helpers/session'

export const resetFTV = () => {
  removeCookie('th_ftv')
}

export const checkHasFitProperties = (fit: Partial<Fit>) =>
  !!fit && Object.keys(fit || {}).length > 0
